<div class="card-scoreboard_stats" *ngIf="event" [class.set-game-scoreboard]="!isTennis">
    <div class="card-scoreboard_stats-values card-scoreboard_stats-values-set">
        <div class="card-scoreboard_stats-column card-scoreboard_stats-column-turn">
            <div class="cell highlight" [ngClass]="{ 'serving-dot': turn === 1 }"></div>
            <div class="cell highlight" [ngClass]="{ 'serving-dot': turn === 2 }"></div>
        </div>
        <div class="card-scoreboard_stats-column card-scoreboard_stats-column-points" *ngIf="isTennis">
            <div class="cell highlight bold">{{ score.participant1.points }}</div>
            <div class="cell highlight bold">{{ score.participant2.points }}</div>
        </div>

        <div class="card-scoreboard_stats-column card-scoreboard_stats-column-set" *ngFor="let setIndex of setsArray; index as i">
            <div class="cell" [ngClass]="{ highlight: isHighlighedSet(i, 1) }">{{ getSetScore(i, 1) }}</div>
            <div class="cell" [ngClass]="{ highlight: isHighlighedSet(i, 2) }">{{ getSetScore(i, 2) }}</div>
        </div>
    </div>
</div>
